import UrlEndpoints from "../client/UrlEndpoints";
import axios from 'axios';
import { 
    TRANSLATE_LOADING_ACTION, 
    TRANSLATE_GET_ISSUES_SUCCESS_ACTION, 
    TRANSLATE_GET_ISSUES_ERROR_ACTION,
    TRANSLATE_DELETE_ISSUE_SUCCESS_ACTION, 
    TRANSLATE_DELETE_ISSUE_ERROR_ACTION,
    TRANSLATE_GET_ISSUE_SUCCESS_ACTION,
    TRANSLATE_GET_ISSUE_ERROR_ACTION,
    TRANSLATE_PATCH_ISSUE_SUCCESS_ACTION,
    TRANSLATE_PATCH_ISSUE_ERROR_ACTION
} from '../translates/Translates';
import {getRequestConfig} from '../client/helpers/Helper';

export const SET_LOADING_GET_ISSUES = 'SET_LOADING_GET_ISSUES';
export const GET_ISSUES = 'GET_ISSUES';
export const GET_ISSUES_SUCCESS = 'GET_ISSUES_SUCCESS';
export const GET_ISSUES_ERROR = 'GET_ISSUES_ERROR';

export const SET_LOADING_DELETE_ISSUE = 'SET_LOADING_DELETE_ISSUE';
export const DELETE_ISSUE = 'DELETE_ISSUE';
export const DELETE_ISSUE_SUCCESS = 'DELETE_ISSUE_SUCCESS';
export const DELETE_ISSUE_ERROR = 'DELETE_ISSUE_ERROR';

export const SET_LOADING_GET_ISSUE = 'SET_LOADING_GET_ISSUE';
export const GET_ISSUE = 'GET_ISSUE';
export const GET_ISSUE_SUCCESS = 'GET_ISSUE_SUCCESS';
export const GET_ISSUE_ERROR = 'GET_ISSUE_ERROR';

export const SET_LOADING_PATCH_ISSUE = 'SET_LOADING_PATCH_ISSUE';
export const PATCH_ISSUE = 'PATCH_ISSUE';
export const PATCH_ISSUE_SUCCESS = 'PATCH_ISSUE_SUCCESS';
export const PATCH_ISSUE_ERROR = 'PATCH_ISSUE_ERROR';

export const TOGGLE_EDIT_ISSUE_MODAL = 'TOGGLE_EDIT_ISSUE_MODAL';

const setLoadingGetIssues = () => {
    return {
        type: SET_LOADING_GET_ISSUES,
        payload: TRANSLATE_LOADING_ACTION
    }
}

const getIssues = (page, filter_ids, filter_processes) => {
    let url = UrlEndpoints.GET_ISSUES;
    let request_url = UrlEndpoints.getUrlEndpoint(url);
    let request_config = {};
    request_config = getRequestConfig();
    request_config.params = {
        page: page,
        filter_ids: filter_ids,
        filter_processes: filter_processes
    }
    return {
        type: GET_ISSUES,
        payload: axios.get(request_url, request_config)
    }
}

const getIssuesSuccess = () => {
    return {
        type: GET_ISSUES_SUCCESS,
        payload: TRANSLATE_GET_ISSUES_SUCCESS_ACTION
    }
}

const getIssuesError = () => {
    return {
        type: GET_ISSUES_ERROR,
        payload: TRANSLATE_GET_ISSUES_ERROR_ACTION
    }
}

const setLoadingDeleteIssue = () => {
    return {
        type: SET_LOADING_DELETE_ISSUE,
        payload: TRANSLATE_LOADING_ACTION
    }
}

const deleteIssue = (id) => {
    let request_url = UrlEndpoints.getUrlEndpoint(UrlEndpoints.DELETE_ISSUE, id);
    let request_config = {};
    request_config = getRequestConfig();
    return {
        type: DELETE_ISSUE,
        payload: axios.delete(request_url, request_config)
    }
}

const deleteIssueSuccess = () => {
    return {
        type: DELETE_ISSUE_SUCCESS,
        payload: TRANSLATE_DELETE_ISSUE_SUCCESS_ACTION
    }
}

const deleteIssueError = () => {
    return {
        type: DELETE_ISSUE_ERROR,
        payload: TRANSLATE_DELETE_ISSUE_ERROR_ACTION
    }
}

const setLoadingGetIssue = () => {
    return {
        type: SET_LOADING_GET_ISSUE,
        payload: TRANSLATE_LOADING_ACTION
    }
}

const getIssue = (id) => {
    let url = UrlEndpoints.GET_ISSUE;
    let request_url = UrlEndpoints.getUrlEndpoint(url, id);
    let request_config = {};
    request_config = getRequestConfig();
    return {
        type: GET_ISSUE,
        payload: axios.get(request_url, request_config)
    }
}

const getIssueSuccess = () => {
    return {
        type: GET_ISSUE_SUCCESS,
        payload: TRANSLATE_GET_ISSUE_SUCCESS_ACTION
    }
}

const getIssueError = () => {
    return {
        type: GET_ISSUE_ERROR,
        payload: TRANSLATE_GET_ISSUE_ERROR_ACTION
    }
}

const setLoadingPatchIssue = () => {
    return {
        type: SET_LOADING_PATCH_ISSUE,
        payload: TRANSLATE_LOADING_ACTION
    }
}

const patchIssue = (data) => {
    let url = UrlEndpoints.PATCH_ISSUE;
    let request_url = UrlEndpoints.getUrlEndpoint(url, data.id);
    let request_config = {};
    request_config = getRequestConfig();
    return {
        type: PATCH_ISSUE,
        payload: axios.patch(request_url, data, request_config)
    }
}

const patchIssueSuccess = () => {
    return {
        type: PATCH_ISSUE_SUCCESS,
        payload: TRANSLATE_PATCH_ISSUE_SUCCESS_ACTION
    }
}

const patchIssueError = () => {
    return {
        type: PATCH_ISSUE_ERROR,
        payload: TRANSLATE_PATCH_ISSUE_ERROR_ACTION
    }
}

const toggleEditIssueModal = (open=false, force=false) => {
    return {
        type: TOGGLE_EDIT_ISSUE_MODAL,
        payload: {open, force}
    }
}


export {
    setLoadingDeleteIssue,
    deleteIssue,
    deleteIssueSuccess,
    deleteIssueError,
    setLoadingGetIssues,
    getIssues,
    getIssuesSuccess,
    getIssuesError,
    setLoadingGetIssue,
    getIssue,
    getIssueSuccess,
    getIssueError,
    setLoadingPatchIssue,
    patchIssue,
    patchIssueSuccess,
    patchIssueError,
    toggleEditIssueModal
}
